import roleNameMatches from "./roleNameMatches";


function canViewStatus(status, auth){
    const {
        user: {
            user: { organizationalUnitRoles },
            permissions: {OverrideWorkflow} = {},
        },
        isAdmin
    } = auth;

    return isAdmin || organizationalUnitRoles.some(({role: {name}}) => roleNameMatches(status.role, name)) || OverrideWorkflow;
}


export default canViewStatus;